<script lang="ts">
	import { Route } from "svelte-routing"
	import { onMount } from "svelte"

	import { LoadingPage } from "misc-ui"
	import { pageLoader } from "../../../modules/auth/onUserLogin"
	import type { Component } from "../../../types/SvelteTypes"
	import { NEXT_ROUTE_KEY } from "../../routes/Routes"
	import { ErrorIndicator } from "luxedo-comps"

	interface Props {
		component: Component
		path: string
	}

	let { component, path }: Props = $props()

	let redirectPath: string = "/login"
	let isLoading = $state(true)

	function redirect() {
		const currentUrl = new URL(window.location.href)
		const loginUrl = new URL(redirectPath, window.location.origin)

		const params = new URLSearchParams(currentUrl.search)
		const nextPath = `${currentUrl.pathname}${currentUrl.search}${currentUrl.hash}`

		params.set(NEXT_ROUTE_KEY, nextPath)

		loginUrl.search = params.toString()
		window.location.replace(loginUrl.toString())
	}

	onMount(async () => {
		if (redirectPath === path)
			throw new Error("Cannot set a redirect path to be the same as path - a loop will occur.")
	})

	async function onRouteMount() {
		const isUserLoggedIn = await pageLoader.initPageLoad()
		if (!isUserLoggedIn) return redirect()
		isLoading = false
	}
</script>

<Route {path}>
	{#snippet children({ params })}
		{#await onRouteMount()}
			<LoadingPage />
		{:then}
			{@const SvelteComponent = component}
			<SvelteComponent {params} />
		{:catch}
			<ErrorIndicator errorMessage="Failed to load." linkToSupport />
		{/await}
	{/snippet}
</Route>

<style>
</style>
